import { API_LIMIT_DATA } from '../utils/constants';
import * as actions from './constants';

const initialState = {
  list: null,
  offset: 0,
  hasMore: false,
  categories: null
};

// eslint-disable-next-line default-param-last
export default function discoverReducer(state = initialState, action) {
  switch (action.type) {
    case actions.ADD_DISCOVER_DATA:
      return {
        ...state,
        list: action.payload.data.length === 0 ? null : action.payload.data,
        offset: action.payload.offset,
        hasMore: action.payload.data.length === API_LIMIT_DATA
      };

    case actions.UPDATE_DISCOVER_DATA:
      return {
        ...state,
        list: [...state.list, ...action.payload.data],
        offset: action.payload.offset,
        hasMore: action.payload.data.length === API_LIMIT_DATA
      };

    case actions.INIT_CATEGORY_DATA:
      return {
        ...state,
        categories: action.payload.data
      };
    default:
      return state;
  }
}
